exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PortfolioSettings-module__portfolio-settings___2R_cy .PortfolioSettings-module__cog___3m5Fz{font-size:20px;color:#b4bac3;cursor:pointer;margin-bottom:1rem}.PortfolioSettings-module__portfolio-settings___2R_cy .PortfolioSettings-module__modal-content___18I6q{display:grid;gap:.5rem}.PortfolioSettings-module__portfolio-settings___2R_cy .PortfolioSettings-module__modal-content___18I6q .PortfolioSettings-module__secondary-title___gyltz{font-weight:700;margin:.5rem 0 0}", ""]);

// exports
exports.locals = {
	"portfolio-settings": "PortfolioSettings-module__portfolio-settings___2R_cy",
	"cog": "PortfolioSettings-module__cog___3m5Fz",
	"modal-content": "PortfolioSettings-module__modal-content___18I6q",
	"secondary-title": "PortfolioSettings-module__secondary-title___gyltz"
};